module.exports = __webpack_public_path__ + "7084cea695cd10b52f83cda06853de0d.svg";